<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Services de la Poste" />
            <ServicePoste />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import ServicePoste from '../Services/ServicePoste'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ServicePostePage',
    components: {
        NavBar,
        PageTitle,
        ServicePoste,
        FooterComp,
    }
}
</script>